import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import AnimatedArrow from "./AnimatedArrow";

export default function NotFoundPage() {
  const { t } = useLanguage();

  return (
    <section className="flex min-h-[70vh] items-center bg-white pb-24 pt-40">
      <div className="container-industrial text-center">
        <div className="font-display uppercase tracking-[0.3px] text-8xl font-normal text-accent sm:text-9xl">
          {t("notFoundEyebrow")}
        </div>
        <h1 className="mt-4 font-display uppercase text-[40px] font-medium tracking-[0.3px] text-ink md:text-[45px]">
          {t("notFoundTitle")}
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-steel-600">
          {t("notFoundDescription")}
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <Link to="/" className="btn-primary">
            {t("notFoundCtaHome")}
            <AnimatedArrow />
          </Link>
          <Link to="/catalog" className="btn-dark-outline">
            {t("notFoundCtaCatalog")}
          </Link>
        </div>
      </div>
    </section>
  );
}
